<template>
  <div>
    <div class="oper_box">
      <el-button @click="addFirstOrder = true">
        <img src="@/assets/button_imgs/tianjia.png" alt="" />
        添加一级项目
      </el-button>
      <el-button @click="addClick(2)">
        <img src="@/assets/button_imgs/tianjia.png" alt="" />
        添加负分项
      </el-button>
    </div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      :summary-method="getSummaries"
      show-summary
      :header-cell-style="{
        'background-color': '#EEEEEE',
        color: '#333333',
        height: '60px',
      }"
    >
      <el-table-column label="一级项目" width="220">
        <template slot-scope="scope">
          <el-input
            class="one_input"
            :class="scope.row.stateNull == 1 ? 'redtes' : ''"
            type="textarea"
            autosize
            @input="isNullState(scope.row, 'name')"
            v-model.trim="scope.row.name"
          ></el-input>
          <div class="oper_box">
            <el-button
              type="primary"
              class="add_bz"
              v-if="scope.row.buckleType == 1 || !scope.row.buckleType"
              @click="addSecondClick(scope.row, scope.$index)"
            >
              <img src="@/assets/button_imgs/tianjia.png" alt="" />
              添加内容及评分标准
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="项目分" width="80" prop="projectScore">
        <template slot-scope="scope">
          <div v-if="scope.row.buckleType == 1 || !scope.row.buckleType">
            {{ sumScore(scope.row) }}
          </div>
          <div v-else-if="scope.row.buckleType && scope.row.buckleType == 2">/</div>
        </template>
      </el-table-column>
      <el-table-column label="内容及评分标准" width="320" class-name="table_3">
        <template slot-scope="scope">
          <div
            class="text_input"
            ref="text"
            v-for="(item, index) in scope.row.child"
            :key="index"
          >
            <el-input
              type="textarea"
              autosize
              @input="isNullState(item, 'content')"
              :class="item.contentNull == 1 ? 'redtes' : ''"
              placeholder="请输入内容"
              v-model.trim="item.content"
            ></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="分值" width="80" class-name="table_3">
        <template slot-scope="scope">
          <div
            class="text_input"
            :class="scope.row.buckleType == 1 ? 'lh75' : ''"
            v-for="(item, index) in scope.row.child"
            :key="index"
          >
            <el-input
              v-if="scope.row.buckleType == 1 || !scope.row.buckleType"
              :class="item.scoreNull == 1 ? 'redtext' : ''"
              @input="isNullState(item, 'scoreValue')"
              v-model.trim="item.scoreValue"
            ></el-input>
            <!-- 负分项 -->
            <p
              v-else-if="scope.row.buckleType && scope.row.buckleType == 2"
              style="color: red; text-align: left"
            >
              扣分项不需要指定分数，根据实际规定扣分即可
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="得分" width="80" class-name="table_3">
        <template slot-scope="scope">
          <div
            style="line-height: 75px"
            v-for="(item, index) in scope.row.child"
            :key="index"
            class="text_input"
          ></div>
        </template>
      </el-table-column>
      <el-table-column label="扣分细节" width="80" class-name="table_3">
        <template slot-scope="scope">
          <div
            style="line-height: 75px"
            v-for="(item, index) in scope.row.child"
            :key="index"
            class="text_input"
          ></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="operation"
        label=""
        width="180"
        class-name="table_3"
      >
        <template slot-scope="scope">
          <div
            style="line-height: 75px"
            v-for="(item, index) in scope.row.child"
            :key="index"
            class="text_input"
          >
            <el-button
              type="text"
              :disabled="index == 0"
              @click="moveUp(index, scope.row.child)"
              >上移</el-button
            >
            <el-button
              type="text"
              @click="moveDown(index, scope.row.child)"
              :disabled="index == scope.row.child.length - 1"
              >下移</el-button
            >
            <el-button
              type="text"
              @click="deleteClick(scope.row, scope.$index, index)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加一级项目弹窗 -->
    <div class="modify">
      <el-dialog
        title="添加一级项目"
        :visible.sync="addFirstOrder"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p>一级项目名称：</p>
          <el-input
            v-model.trim="titleName"
            placeholder="请输入一级项目名称"
          ></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              addFirstOrder = false;
              titleName = '';
            "
            >取 消</el-button
          >
          <el-button type="primary" @click="addClick(1)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          buckleType: 1, // 是否扣分项 1 否 2 是
          name: "一级项目名称", // 一级项目名称
          projectScore: 0, // 项目分
          stateNull: "0", // 是否为空状态 0false 1true
          child: [
            {
              content: "", // 内容及评分标准
              scoreValue: 10, // 分值
              contentNull: "0", // 是否为空状态 0false 1true
              scoreNull: "0", // 是否为空状态 0false 1true
            },
          ],
        },
      ],
      addFirstOrder: false, // 添加一级弹窗
      titleName: "", // 一级名称
      total: 1, // 合计
    };
  },
  methods: {
    // 添加
    addClick(type) {
      let obj = {};
      if (type == 1) {
        obj = {
          buckleType: 1, // 是否扣分项
          name: this.titleName, // 一级项目名称
          projectScore: 0, // 项目分
          stateNull: "0", // 是否为空状态 0false 1true
          child: [
            {
              content: "", // 内容及评分标准
              scoreValue: "", // 分值
              contentNull: "0", // 是否为空状态 0false 1true
              scoreNull: "0", // 是否为空状态 0false 1true
              // score: "", // 得分
              // address: "", // 扣分细节
            },
          ],
        };
        this.titleName = ""; // 置空
      } else if (type == 2) {
        // 添加扣分项
        obj = {
          buckleType: 2, // 是否扣分项
          name: "扣分", // 一级项目名称
          projectScore: -1, // 项目分
          stateNull: "0", // 是否为空状态 0false 1true
          child: [
            {
              content: "", // 内容及评分标准
              scoreValue: "无", // 分值
              contentNull: "0", // 是否为空状态 0false 1true
              scoreNull: "0", // 是否为空状态 0false 1true
            },
          ],
        };
      }

      this.tableData.push(obj);
      console.log(this.tableData);
      this.addFirstOrder = false;
    },
    // 添加二级
    addSecondClick(row, index) {
      let obj = {
        content: "", // 内容及评分标准
        scoreValue: "", // 分值
        contentNull: "0", // 是否为空状态 0false 1true
        scoreNull: "0", // 是否为空状态 0false 1true
      };
      this.tableData[index].child.push(obj);
    },
    // 上移
    moveUp(index, newarr) {
      let arr = newarr;
      arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
    },
    // 下移
    moveDown(index, newarr) {
      let arr = newarr;
      arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]));
    },
    // 删除
    deleteClick(row, index, indexs) {
      console.log(row);
      if (row.child.length == 1) {
        // 删除整个父级
        this.tableData.splice(index, 1);
      } else {
        this.tableData[index].child.splice(indexs, 1);
      }
    },
    // 名称不为空清除红框
    isNullState(row, type) {
      if (type == "name") {
        if (row.name == "") {
          return;
        } else if (row.name !== "" && row.stateNull) {
          row.stateNull = "0";
        }
      } else if (type == "content") {
        if (row.content == "") {
          return;
        } else if (row.content !== "" && row.contentNull) {
          row.contentNull = "0";
        }
      } else {
        if (row.scoreValue == "") {
          return;
        } else if (row.scoreValue !== "" && row.scoreNull) {
          row.scoreNull = "0";
        }
      }
    },
    //合计
    getSummaries(param) {
      let { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        data = data.filter((item) => {
          if (item.buckleType == 1 || !item.buckleType) {
            return item; // 扣分项不参与合计计算
          }
        });
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === "projectScore") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });
      this.total = sums[1];
      return sums;
    },
  },
  computed: {
    // 计算二级小节的合计
    sumScore() {
      return function (row) {
        // console.log(row.child.reduce((a, curr) => a + curr.scoreValue, 0));
        if (row.buckleType == 1 || !row.buckleType) {
          row.projectScore = row.child.reduce(
            (a, curr) => a + Number(curr.scoreValue),
            0
          );
          return row.projectScore;
        }
      };
    },
  },
  created() {
    if (this.$route.query.type == 1) {
      // 编辑回显
      let row = this.$storage.sessionGet("rowObj", true);
      this.tableData = JSON.parse(row.ContentTxt).map((item) => {
        if (item.buckleType && item.buckleType == 2) {
          item.projectScore = -1;
        }
        return item;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  min-width: 88px;
  height: 40px;
  opacity: 1;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 112px;
    height: 40px;
    background: #ebecf1;
    border-radius: 3px;
    letter-spacing: 1px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #000000;
    &:nth-child(1) {
      min-width: 140px;
    }
    span {
      display: flex;
      align-items: center;
    }
    span > img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table__cell {
  text-align: center;
}
.cell {
  text-align: center;
}
.red {
  border: 1px solid red;
  border-radius: 4px;
  &:focus {
    border-color: red !important;
  }
}
.add_bz {
  //   margin-top: 24px;
  background: #409eff !important;
  color: #fff !important;
}
.text_input {
  margin-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
  padding: 0px 10px 6px 10px;
  height: 75px;

  &:last-child {
    border: none !important;
    height: 100%;
  }
  ::v-deep .el-textarea__inner {
    // max-height: 60px !important;
    // width: 290px;
    resize: none;
    height: 70px !important;
  }
}
::v-deep .table_3 {
  .cell {
    padding: 0 !important;
  }
}
.modify {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    // justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    display: flex;
    align-items: center;
    p {
      width: 140px;
    }
    ::v-deep .el-input__inner {
      width: 280px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 500px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
      }
    }
  }
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}
::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }
    &:nth-child(2) {
      background: #0084ea;
    }
  }
}
.one_input {
  ::v-deep .el-textarea__inner {
    resize: none;
    width: 196px;
    height: 40px !important;
  }
}
.redtes {
  ::v-deep .el-textarea__inner {
    border-color: red !important;
  }
}
.redtext {
  ::v-deep .el-input__inner {
    border-color: red !important;
  }
}
.lh75 {
  line-height: 75px;
}
</style>